import ExamTemplateStatisticsContainer from '@src/components/exam/examtemplate/ExamTemplateStatisticsContainer';
import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';

// -- Prop types
// ----------
type IExamTemplateStatisticsPageProps = WithRouterProps;

const ExamTemplateStatisticsPage = (props: IExamTemplateStatisticsPageProps) => <ExamTemplateStatisticsContainer courseId={props.params.courseId} />;

export default withRouter<IExamTemplateStatisticsPageProps>(ExamTemplateStatisticsPage);
